import { IconName } from "@elearning-platform/ui";

import { ReactComponent as ModuleIcon } from './images/moduleIcon.svg';

export const Config = {
  moduleName: 'provisions',
  dependencies: [],
  label: 'competence.app.provisions.title',
  Icon: ModuleIcon,
  urls: ['/provisions/*', '/provisions'],
  routeName: 'api_provision',
  routes: {
    init: '/',
    userDashboard: '/user-dashboard',
    userSheets: '/user-sheets',
    adminOfwcaDashboard: '/admin-ofwca-dashboard',
    userMonthSheet: '/user-sheets/:year/:month',
    contract: '/sheets/:sheetId/contracts/:contractId',
    sheetsAndCompaintsList: '/sheets',
    sheetDetails: '/sheets/:sheetId',
    userWithoutDocuments: '/users-without-docs/:id',
    complaintDetails: '/complaints/:id',
    complaintAdd: '/complaints/add',
    complaintsList: '/complaints-list/:type',
    administratorDashboard: '/administrator-dashboard',
  },
  options: {},
  theme: {},
  ignoreModuleFromGlobalState: true,
  modernIconName: IconName.PageCommisions,
};
